import { createFileRoute } from '@tanstack/react-router'
import { LessonPage } from '@/features/learn/lesson-page'

export const Route = createFileRoute('/_authenticated/learn/$lessonKey')({
  staticData: { title: 'Lesson' },
  component: function LessonRoute() {
    const { lessonKey } = Route.useParams()
    return <LessonPage key={lessonKey} lessonKey={lessonKey} />
  },
})
